<ifr-page-title pageTitle="'ACCOUNT_CORRECTION_ACCOUNTS_PAGE_TITLE' | translate "/>
<div class="tab-pane fade active in corrections-affix" id="wid-accountCorrections-tab-content-0">
    <iflx-account-corrections-accounts></iflx-account-corrections-accounts>
</div>
